{
  "agendahero": "agendahero",
  "untitled_schedule": "Untitled schedule",
  "untitled_entry": "Untitled item",
  "cloned_entry_title": "{{originalTitle}} (copy)",
  "error_boundary": {
    "title": "An error occurred",
    "message": "Something went wrong. Please try again.",
    "reload": "Reload",
    "chunk_title": "An update is available",
    "chunk_message": "Reload the page to get the latest version of <nowrap>Agenda Hero</nowrap>."
  },
  "suspension": {
    "title": "Account Suspended",
    "message": "This account has been suspended. If you feel this has been in error, please contact support for assistance.",
    "contact_support": "Contact Support"
  },
  "done": "Done",
  "show_hidden_entries": "Show hidden items",
  "hide_hidden_entries": "Hide hidden items",
  "hide_entry": "Hide item",
  "unhide_entry": "Unhide item",
  "page_title_suffix": "Agenda Hero",
  "default_error_code_messages": {
    "EntryScheduledMessageLimitReached": "You've reached the maximum number of messages per item.",
    "EntryMessageInPast": "Messages cannot be scheduled in the past. Please change the date of the item or the time the text goes out.",
    "LabelExists": "A label with the same name already exists."
  },
  "recurrence_select": {
    "once": "Does not repeat",
    "daily": "Daily",
    "weekly": "Weekly",
    "biweekly": "Every other week",
    "monthly": "Monthly",
    "yearly": "Yearly",
    "aria": "Recurrence",
    "month_aria": "Month recurrence",
    "month_day": "Every month on day {{date}}",
    "month_nth": "Every month on the {{index}}{{nth}} {{date}}"
  }
}
